import { Control } from './control';

export class Tab {
  constructor(
    public controls?: Control[],
    public key?: string,
    public label?: string,
    public сontrolType?: number,
  ) { }
}
